import Icon from '../icon';
import BevSafeText from '../bev-safe-text';
import { ICONS, type IconType } from '../icon/icon';
import type { EditorialOverviewTag } from './editorial-overview.types';

const TAG_ICON_MAP: Record<string, IconType> = {
	duration: 'time',
	'max-occupancy': 'occupancy',
	category: 'experience',
};

const MAX_TAGS = 4;

const isIconType = (value: string): value is IconType => ICONS.includes(value as IconType);

function getTagIcon(tag: EditorialOverviewTag): IconType {
	if (tag.icon && isIconType(tag.icon)) {
		return tag.icon;
	}
	return TAG_ICON_MAP[tag.type] ?? 'information';
}

type EditorialOverviewTagsProps = {
	tags: EditorialOverviewTag[];
};

export default function EditorialOverviewTags({ tags }: EditorialOverviewTagsProps) {
	// Don't render if fewer than 2 tags
	if (tags.length < 2) {
		return null;
	}

	return (
		<div className="flex flex-wrap gap-x-inline-xs gap-y-stack-xs lg:gap-y-150">
			{tags.slice(0, MAX_TAGS).map((tag, index) => (
				<div
					key={index}
					className="flex items-center gap-x-inline-xs px-tag-padding-x py-tag-padding-y lg:py-100 rounded-sm bg-surface-raised-subtle"
				>
					<Icon icon={getTagIcon(tag)} className="w-200 h-200" />
					<span className="text-caption text-info-text">
						<BevSafeText>{tag.label}</BevSafeText>
					</span>
				</div>
			))}
		</div>
	);
}
